import { Config as vueLibConfig } from "@switchsystems/coactive-vue-lib";

export const DUTIES_DEFAULT_DISPLAYORDER = 999;

const config = {
  locations: vueLibConfig.locations,
  dutiesQualifiedFor: [
    {
      name: "Manager",
      shortName: "Manager",
      value: "manager",
      display: {
        "add-activity": true,
        "add-shift": true,
      },
      displayOrder: 1,
    },
    {
      name: "Head of Care",
      shortName: "HOC",
      value: "hoc",
      display: {
        "add-shift": true,
      },
      displayOrder: 2,
    },
    {
      name: "Senior",
      shortName: "Senior",
      value: "senior",
      display: {
        "add-activity": true,
        "add-shift": true,
      },
      displayOrder: 3,
    },
    {
      name: "Senior / Team Leader",
      shortName: "Senior/Team Leader",
      value: "senior-team-lead",
      display: {
        "add-activity": true,
        "add-shift": true,
      },
      displayOrder: 4,
    },
    {
      name: "Home Lead",
      shortName: "Home Lead",
      value: "home-lead",
      display: {
        "add-activity": true,
        "add-shift": true,
      },
      displayOrder: 5,
    },
    {
      name: "Dispensing Medication",
      shortName: "Meds",
      value: "meds",
      display: {
        "add-activity": true,
        "add-shift": true,
      },
      displayOrder: 6,
    },
    {
      name: "Driving",
      shortName: "Driving",
      value: "driving",
      display: {
        "add-activity": true,
        "add-shift": true,
      },
      displayOrder: 7,
    },
    {
      name: "Admin",
      shortName: "Admin",
      value: "admin",
      display: {
        "add-activity": true,
        "add-shift": true,
      },
      displayOrder: 8,
    },
    {
      name: "Floating",
      shortName: "Floating",
      value: "floating",
      display: {
        "add-activity": false,
        "add-shift": true,
      },
      displayOrder: 9,
    },
    {
      name: "On-call",
      shortName: "On-call",
      value: "oncall",
    },
  ],
  FULLCALENDAR_LICENSE_KEY: "0957799172-fcs-1668766443",
  rotaConfiguration: {
    support: {
      name: "Support",
      type: "support",
      view: {
        hours: "standard",
      },
      hasSupportActivities: true,
      hasActivities: true,
    },
    care: {
      name: "Care",
      type: "care",
      view: {
        hours: "grouped",
      },
      hasSupportActivities: false,
      hasActivities: false,
    },
    domestic: {
      name: "Domestic",
      type: "generic",
      view: {
        hours: "standard",
      },
      hasSupportActivities: false,
      hasActivities: false,
    },
    office: {
      name: "Office",
      type: "generic",
      view: {
        hours: "standard",
      },
      hasSupportActivities: false,
      hasActivities: false,
    },
    combined: {
      name: "Combined",
      type: "combined",
      view: {
        hours: "standard",
      },
      hasSupportActivities: true,
      hasActivities: true,
    },
  },
  shiftScheduleTypes: [{ name: "care" }, { name: "break" }],
  activityTypes: [
    {
      name: "Appointment (e.g. GP, eye test)",
      value: "appointment",
      icon: "medkit",
    },
    {
      name: "Care",
      value: "care",
      icon: ["fas", "hand-holding-medical"],
    },
    {
      name: "Office / other",
      value: "office",
      icon: "cog",
    },
    {
      name: "Support",
      value: "support",
      icon: "hand-holding-hand",
    },
  ],
};

export default config;
